<template>
  <main class="home" v-if="payload">
    <section class="home__branding">
      <img src="@/assets/logo.svg" alt="ExLaB Logo">
    </section>
    <section class="home__slideshow">
      <div class="slideshow" @mouseleave="resetImage()">
        <div class="slideshow__item"
          :class="{'slideshow__item--active': true}"
          @mousemove="transformImage"
          @click="clickToPlayVideo"
          :style="{transform: [transformCSS], transition: transitionCSS}">
          <video :muted="muted" class="slideshow__item-video" :width="width" :height="height" ref="video" playsinline autoplay>
            <source :src="payload.slideshow[activeSlideshow].video"  type="video/mp4">
          </video>
        </div>
      </div>
    </section>
    <button class="sound-toggle" v-html="soundText" @click="soundToggle = !soundToggle"></button>
    <marquee-text :duration="15" :repeat="5" :paused="marqueeState" class="home__marquee">
      <ul class="announcements">
        <li v-for="(announcement, key) in payload.announcements" :key="`annoucement${key}`" class="announcements__item">
          <a :href="announcement.link" target="_blank" rel="noopener noreferrer" v-html="announcement.text" class="ff-sans"></a>
        </li>
      </ul>
    </marquee-text>
  </main>
</template>

<script>
import ApiPage from '@/services/ApiPage'
import MarqueeText from 'vue-marquee-text-component'

export default {
  name: 'home',
  extends: ApiPage,
  components: {
    MarqueeText
  },
  data() {
    return {
      payload: null,
      activeSlideshow: 0,
      styles: false,
      playerVars: {
        autoplay: 1,
        playsinline: 1,
        controls: 1,
        modestbranding: 1,
        mute: 1
      },
      animation: {
        perspective: `${Math.floor((window.innerWidth || document.documentElement.clientWidth) * 0.75 - 80)}px`,
        rotateX: 0,
        rotateY: 0,
        translateZ: 0,
        transition: 'all 0.3s linear'
      },
      transformCSS: '', // `perspective(${this.animation.perspective}) translateZ(${this.animation.translateZ}px) rotateX(${this.animation.rotateX}deg) rotateY(${this.animation.rotateY}deg)`,
      transitionCSS: '',
      marqueeState: false,
      soundToggle: false,
      muted: !this.soundToggle,
      soundText: '(sound on)'
    }
  },
  computed: {
    width: function() {
      let width = window.innerWidth || document.documentElement.clientWidth
      let scale = width > 768 ? 0.66 : 0.90
      return Math.floor(width * scale)
    },
    height: function() {
      let width = window.innerWidth || document.documentElement.clientWidth
      let scale = width > 768 ? 0.66 : 0.90
      return Math.floor((width * scale) / 1.77)
    }
  },
  watch: {
    'payload.slideshow': function(newVal) {
      this.activeSlideshow = this.getRandomInt(0, (newVal.length - 1))
    },
    soundToggle: function(newVal) {
      this.soundText = newVal ? '(sound off)' : '(sound on)'
      this.muted = !newVal
    }
  },
  methods: {
    loadNewVideo() {
      let currentActiveSlideshow = this.activeSlideshow
      let newActiveSlideshow = this.getRandomInt(0, (this.payload.slideshow.length - 1))

      // update new active slideshow with new number
      this.activeSlideshow = (newActiveSlideshow !== currentActiveSlideshow) ? newActiveSlideshow : this.getRandomInt(0, (this.payload.slideshow.length - 1))

      // if active slideshow is still the same update again
      if (this.activeSlideshow === currentActiveSlideshow) {
        newActiveSlideshow = this.getRandomInt(0, (this.payload.slideshow.length - 1))
        this.activeSlideshow = (newActiveSlideshow !== this.activeSlideshow) ? newActiveSlideshow : this.getRandomInt(0, (this.payload.slideshow.length - 1))
      }

      this.addCssAnimation()
    },
    clickToPlayVideo() {
      if ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) > 768) return false

      this.$refs.video.load()
    },
    getRandomInt(min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min)) + min // The maximum is exclusive and the minimum is inclusive
    },
    transformImage($evt) {
      if ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 769) return false

      let image = $evt.target.getBoundingClientRect()
      let mouseX = $evt.pageX - image.left
      let mouseY = $evt.pageY - image.top
      let width = $evt.target.clientWidth
      let scale = 0.5

      this.animation.translateZ = 10
      this.animation.rotateX = (0.5 - (mouseY / width)) * 80 * scale
      this.animation.rotateY = -(0.5 - (mouseX / width)) * 80 * scale
      this.animation.transition = 'none'

      this.transformCSS = `perspective(${this.animation.perspective}) translateZ(${this.animation.translateZ}px) rotateX(${this.animation.rotateX}deg) rotateY(${this.animation.rotateY}deg)`
      this.transitionCSS = 'none'
    },
    resetImage() {
      this.animation.translateZ = 0
      this.animation.rotateX = 0
      this.animation.rotateY = 0
      this.animation.transition = 'all 325ms linear'

      this.transformCSS = `perspective(${this.animation.perspective}) translateZ(${this.animation.translateZ}px) rotateX(${this.animation.rotateX}deg) rotateY(${this.animation.rotateY}deg)`
      this.transitionCSS = this.animation.transition
    },
    addCssAnimation() {
      // create and add styles to head
      if (!this.styles) {
        this.styles = document.createElement('style')
        this.styles.type = 'text/css'
        document.head.appendChild(this.styles)
      }
      // calculate perspective
      let perspective = `${(window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) * 0.9}px`

      // create name for animation
      let animationName = `transformImage${this.activeSlideshow}`
      // add styles to sheet
      if (this.styles) {
        this.styles.sheet.insertRule(`@keyframes ${animationName} {
          0% {
            transform: perspective(${perspective}) translateZ(60px)
            rotateX(${this.getRandomInt(10, 21)}deg) rotateY(${this.getRandomInt(-7, 0)}deg);
          }
          25% {
            transform: perspective(${perspective}) translateZ(60px)
            rotateX(${this.getRandomInt(-7, 0)}deg) rotateY(${this.getRandomInt(10, 21)}deg);
          }
          50% {
            transform: perspective(${perspective}) translateZ(60px)
            rotateX(${this.getRandomInt(-10, -21)}deg) rotateY(${this.getRandomInt(0, 7)}deg);
          }
          75% {
            transform: perspective(${perspective}) translateZ(60px)
            rotateX(${this.getRandomInt(0, 7)}deg) rotateY(${this.getRandomInt(-10, -21)}deg);
          }
          100% {
            transform: perspective(${perspective}) translateZ(60px)
            rotateX(${this.getRandomInt(10, 21)}deg) rotateY(${this.getRandomInt(-7, 0)}deg);
          }
        }`, this.styles.length)
      }

      // add animation to element
      let slideshow = document.querySelector('.slideshow__item')
      if (slideshow) {
        slideshow.style.animation = `${animationName} 8s infinite alternate linear`
      } else {
        setTimeout(() => {
          document.querySelector('.slideshow__item').style.animation = `${animationName} 8s infinite alternate linear`
        }, 400)
      }
    }
  },
  mounted() {
    // add CSS animation to mobile transform
    if ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 769) {
      this.addCssAnimation()
    }

    // add event listeners for video
    setTimeout(() => {
      // hide then load then play new video
      this.$refs.video.addEventListener('ended', () => {
        this.$refs.video.style.opacity = 0
        this.loadNewVideo()
        this.$refs.video.load()
      })

      // when new video loaded and playing show video
      this.$refs.video.addEventListener('canplay', () => {
        this.$refs.video.style.opacity = 1
      })

      this.$refs.video.click()
    }, 400)
  }
}
</script>

<style lang="scss" scoped>
.home {
  @include page;
  &__branding {
    width:87.5vw;
    img {
      width: 100%;
      height:auto;
    }
  }
  &__slideshow {
    width:75vw;
    height:80vh;
    position:fixed;
    top:10vh;
    left:12.5vw;
    display:flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    .slideshow {
      display:inline-block;
      padding:2rem;
      &__item {
        background-color:transparent !important;
        /* display:none;
        top:50%;
        left:50%;
        position: absolute;
        transform: translate(-50%, -50%); */
        &--active {
          display:block;
        }
        video {
          background-color:transparent !important;
          transition:opacity 200ms ease-in-out;
          &::-webkit-media-controls, &::-webkit-media-controls-overlay-play-button {
            display: none;
            -webkit-appearance: none;
          }
        }
      }
    }
    &-play {
      text-transform:uppercase;
      margin:1rem 0;
    }
  }
  &__marquee {
    position:fixed;
    bottom:0;
    left:0;
    width:100%;

    .announcements {
      display:flex;
      &__item {
        padding:0 1rem;
        font-size: 1.625rem;
        position: relative;
        &:after {

          display:inline-block;
          position:absolute;
          right:-0.5rem;
        }
        a {
          &:hover {
            text-decoration:underline;
          }
        }
      }
    }
  }
  .sound-toggle {
    @include button_reset;
    position:fixed;
    top:50%;
    right:$padding;
    transform:translateY(-50%);
  }
  @media screen and (max-width: 768px) {
    min-height:85vh;
    &__slideshow {
      width:100%;
      height:100%;
      top:0;
      left:0;
      .slideshow {
        padding:0;
      }
    }

    &__branding {
      display:none;
    }

    &__marquee {
      .announcements {
        &__item {
          font-size:$heading--m;
        }
      }
    }
    .sound-toggle {
      top:75%;
      right:50%;
      transform:translateX(50%);
    }
  }
}
</style>

<style lang="scss">
.home {
  .slideshow {
    iframe {
      pointer-events: none;
    }
  }
}
</style>
